import React from 'react';
import classNames from 'classnames';

import { useTranslation } from '../../../../hooks';
import { CircularLessIcon, CircularPlusIcon, LessIcon, PlusIcon } from '../../Icons';
import './Quantity.scss';

export default function Quantity({
	id,
	name,
	//   isRequired,
	disabled,

	// controlled
	value = 0,
	onChange,
	min = 0,
	max = Infinity,
	step = 1,
	circularIcons = true,
	ariaLabelledby,
	//   ...props
}) {
	const { t } = useTranslation();

	return (
		<div className="quantity" id={id} role="group" aria-labelledby={ariaLabelledby}>
			<button
				type="button"
				aria-label={t('remove one')}
				className="quantity__toggle-button"
				onClick={() => onChange({ target: { name, value: Math.max(value - step, min) } })}
				disabled={disabled || value === min}
			>
				<div className="quantity__toggle-icon">
					{circularIcons ? <CircularLessIcon /> : <LessIcon />}
				</div>
			</button>

			<div
				aria-live="polite"
				aria-atomic="true"
				className={classNames({ 'ty-h3': circularIcons, 'ty-b2': !circularIcons })}
			>
				{value}
			</div>

			<button
				type="button"
				aria-label={t('add one')}
				className="quantity__toggle-button"
				onClick={() => onChange({ target: { name, value: Math.min(max, value + step) } })}
				disabled={disabled || value === max}
			>
				<div className="quantity__toggle-icon">
					{circularIcons ? <CircularPlusIcon /> : <PlusIcon />}
				</div>
			</button>
		</div>
	);
}
